import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { HttpClient, HttpEvent, HttpHandler, HttpHeaders, HttpRequest } from '@angular/common/http';
import { catchError, map, switchMap, filter, take } from 'rxjs/operators';
import { ConfigurationService } from './configuration.service'
import { IdentityService } from './identity.service';
import { isNullOrWhiteSpace, isNullOrUndefined } from '../utils/utils';
import { CookieService } from 'ngx-cookie-service';
import { BehaviorSubject, Observable, ReplaySubject, throwError } from 'rxjs';
import { SoftwareInfo } from '../models/assemblea/SoftwareInfo';
import { AssembleaService } from './assemblea.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';

@Injectable()
export class AuthService {

  tokenSubject: BehaviorSubject<string> = new BehaviorSubject<string>(null);

  SaveTokens(user: any) {
    this.identityService.refreshUser(user);
  }

  public RefreshInCorso() {
    return this.isRefreshing == true;
  }
  isRefreshing = false;

  public addToken(request: HttpRequest<any>, token: string) {
    //logtoken console.log({ 'add Token': token, 'request': request });
    return request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }, withCredentials: true
    });
  }


  handleRefrehToken(request: HttpRequest<any>, next: HttpHandler) {

    if (!this.RefreshInCorso()) {
      this.isRefreshing = true;

      this.tokenSubject.next(null);

      return this.GenerateRefreshToken().pipe(
        switchMap((data: any) => {
          if (this.identityService.isLoggedIn) {
            //logtoken console.log({ 'refreshed Token': data });
            this.SaveTokens(data);
            this.tokenSubject.next(data.Token);

            this.isRefreshing = false;
            if (request !== null)
              return next.handle(this.addToken(request, data.Token))
            else
              return new Observable<HttpEvent<any>>();
          }
          else {
            this.isRefreshing = false;
          }
        }),
        catchError(errordata => {
          if (this.identityService.isLoggedIn) {
            console.log({ 'error refresh Token': errordata });
            //this.logOut();
            this.isRefreshing = false;
            return throwError(errordata)
          }
          else {
            this.isRefreshing = false;
            return new Observable<HttpEvent<any>>();
          }
        })
      )
    }
    else {
      //logtoken console.log({ 'this.tokenSubject': this.tokenSubject });
      return this.tokenSubject.pipe(
        filter(token => token != null),
        take(1),
        switchMap(token => {
          //logtoken console.log({ 'token':token });
          if (request == null) return new Observable<HttpEvent<any>>();
          return next.handle(this.addToken(request, token));
        }))
    }

  }

  GenerateRefreshToken() {
    return this.http.post<any>(`${this.serviceUrl}/RefreshToken`, null, { withCredentials: true })
  }
  serviceUrl: string;

  constructor(
    private http: HttpClient,
    private router: Router, private ngxService: NgxUiLoaderService,
    private configService: ConfigurationService, private assembleaService: AssembleaService,
    private identityService: IdentityService, private cookieService: CookieService ) {
    this.configService.OnSettingsLoaded.subscribe(() => {
      this.serviceUrl = this.configService.serverSettings.webApiServiceUrl;
    });
  }

  logIn(username: string, password: string) {

    //let guid = this.cookieService.get('FirstLoginGuid');
    //if (isNullOrWhiteSpace(guid)) {
    //  guid = Guid.create().toString();
    //  this.cookieService.set('FirstLoginGuid', guid);
    //}

    return this.http.post<any>(`${this.serviceUrl}/login`, { username, password }, { withCredentials: true })
      .pipe(map(user => {
        // login successful if there's a jwt token in the response
        //TODO decommentare e aggiungere condizione su 2FA e invio sms
        if (user && user.Token) {
          if (!user.TwoFactorEnabled || isNullOrWhiteSpace(user.PhoneNumber)) {
            this.identityService.setUser(user);
          }
        } else {
          this.identityService.removeUser();
        }
        return user;
      }));
  }


  verify2FA(user: any, otp: string) {


    return this.http.post<any>(`${this.serviceUrl}/Veryfy2FA`, { user, otp },
      { headers: new HttpHeaders({ 'Authorization': `Bearer ${user.Token}` }) }
    ).pipe(map(data => {
      //TODO verificare se risposta ok o ko
      if (data) {
        this.identityService.setUser(data);
      } else {
        this.identityService.removeUser();
      }
      return data;
    }));
  }

  logOut() {
    this.identityService.removeUser();
    this.cookieService.delete('AssembleaNgRefreshToken','/');
    this.router.navigate(['/login-form'], { queryParams: { returnUrl: '/home' } });
  }




 


  handleRefrehPage() {

    if (this.identityService.CanRefresh) {
      this.ngxService.startLoader('Connection');
      window.location.reload();

      return new Observable<any>();

    }
    else {
      this.identityService.refreshNeeded = true;
      //TODO se sono in una pagina non refreshabile non refresha nemmeno quando cambio pagina...
      //Da verificare in cabina al completamento di una votazione
      //console.log({ 'this.refreshSubject': this.refreshSubject });
      return this.identityService.refreshSubject.pipe(
        filter(sbj => sbj == true),
        take(1),
        switchMap(sbj => {

          this.ngxService.startLoader('Connection');
          window.location.reload();

          return new Observable<any>();
        }));
    }

  }

}





@Injectable()
export class AuthGuardService implements CanActivate {

  constructor(private router: Router, private identityService: IdentityService) {

  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | import("@angular/router").UrlTree | import("rxjs").Observable<boolean | import("@angular/router").UrlTree> | Promise<boolean | import("@angular/router").UrlTree> {
    //console.log({ 'route': route, 'state': state})
    if (!this.identityService.isLoggedIn) {
      // not logged in so redirect to login page with the return url
      this.router.navigate(['/login-form'], { queryParams: { returnUrl: state.url } });
      return false;
    }

    // this will be passed from the route config
    // on the data property
    const expectedCapability = route.data['expectedCapability'];

    if (isNullOrUndefined(expectedCapability)) {
      return true;
    }

    if (!isNullOrUndefined(this.identityService.user.Role.Capabilities.find(x => x.CID == expectedCapability))) {
      return true;
    }

    this.router.navigate(['/home']);
    return false;
  }


}
